const redesignKey = 'neb_redesign_';

export const getIsRedesign = (path: string) => path.includes(redesignKey);
